import { takeLatest, put, call, fork, all, select, delay } from "redux-saga/effects"
import * as actions from "@/AppRedux/actions/admin/roomDetailConfig/roomDetailConfigType"
import * as actionCreation from "@/AppRedux/actions/admin/roomDetailConfig"

import { APIPostRequest } from "@/services/connection"
import { SagaIterator } from "redux-saga"
import { API_HEADERS, API_PMS_URL } from "@/constants/ApiSetting"

import { RootState } from "@/AppRedux/reducers"

function* roomDetailsListRequestProcess(): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    // TODO: get current selected language from i18n
    const url = `${API_PMS_URL}/admin/room/list`
    const API_BODY = {
      prop_code: propCode,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRoomDetailsListSuccess(response.data.result_data))
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to get room details list"
      yield put(actionCreation.setRoomDetailsListFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRoomDetailsListFailure(message))
    yield delay(200)
    yield put(actionCreation.clearRoomDetailsProcess())
  }
}

function* roomDetailsGetRequestProcess({ payload }: actions.RoomDetailsGetRequest): SagaIterator {
  try {
    if (!payload?.roomCode) {
      yield put(actionCreation.setRoomDetailsGetFailure("Invalid room code"))
      return
    }

    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/room/get`
    const API_BODY = {
      prop_code: propCode,
      room_code: payload.roomCode,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRoomDetailsGetSuccess(response.data.result_data))
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to get room detail"
      yield put(actionCreation.setRoomDetailsGetFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRoomDetailsGetFailure(message))
    yield delay(200)
    yield put(actionCreation.clearRoomDetailsProcess())
  }
}

function* roomDetailsUpdateRequestProcess({ payload }: actions.RoomDetailsUpdateRequest): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/room/update`
    const API_BODY: actions.RoomDetailsUpdateRequestPayload = {
      prop_code: propCode,
      ...payload,
    }

    console.log("Updating room detail:", API_BODY)

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRoomDetailsUpdateSuccess())
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to update room detail"
      yield put(actionCreation.setRoomDetailsUpdateFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRoomDetailsUpdateFailure(message))
    yield delay(200)
    yield put(actionCreation.clearRoomDetailsProcess())
  }
}

function* roomDetailsSortOrderUpdateRequestProcess({ payload }: actions.RoomDetailsUpdateSortOrderRequest): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/room/sort_order/update`
    const API_BODY: actions.RoomDetailsSortOrderUpdateRequestPayload = {
      prop_code: propCode,
      items: payload,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRoomDetailsUpdateSortOrderSuccess())
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to update sort order"
      yield put(actionCreation.setRoomDetailsUpdateSortOrderFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRoomDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRoomDetailsUpdateSortOrderFailure(message))
    yield delay(200)
    yield put(actionCreation.clearRoomDetailsProcess())
  }
}

function* roomDetailsListRequest() {
  yield takeLatest(actions.ROOM_DETAILS_LIST_REQUEST, roomDetailsListRequestProcess)
}

function* roomDetailsGetRequest() {
  yield takeLatest(actions.ROOM_DETAILS_GET_REQUEST, roomDetailsGetRequestProcess)
}

function* roomDetailsUpdateRequest() {
  yield takeLatest(actions.ROOM_DETAILS_UPDATE_REQUEST, roomDetailsUpdateRequestProcess)
}

function* roomDetailsSortOrderUpdateRequest() {
  yield takeLatest(actions.ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST, roomDetailsSortOrderUpdateRequestProcess)
}

export default function* rootRoomDetailConfigSaga() {
  yield all([
    fork(roomDetailsListRequest),
    fork(roomDetailsGetRequest),
    fork(roomDetailsUpdateRequest),
    fork(roomDetailsSortOrderUpdateRequest),
  ])
}
